import { CreateContactFormModelInner } from '@/views/contactsCreate/model/CreateContactForm.model.ts';

export type ContactsCreateTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  customerDetails: {
    addingResourceFor: string;
    forCustomer: string;
    forSupplier: string;
  };
  form: Record<keyof CreateContactFormModelInner, string>;
  selectClient: {
    button: {
      clearCustomer: string;
      selectCustomer: string;
    };
    customerSectionTitle: string;
  };
  title: {
    create: string;
    update: string;
  };
};

export const contactsCreateTranslation: ContactsCreateTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  customerDetails: {
    addingResourceFor: 'Dodajesz kontakt dla {{forResource}} o nazwie: ',
    forCustomer: 'klienta',
    forSupplier: 'dostawcy',
  },
  form: {
    companyPosition: 'Stanowisko',
    contactOwnerId: 'Opiekun ',
    customer: 'pole techniczne',
    customerChanged: 'pole techniczne',
    displayName: 'Nazwa wyświetlana',
    email: 'Email',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    name: 'Nazwa',
    note: 'Notatka',
    phone: 'Telefon',
    status: 'Status',
  },
  selectClient: {
    button: {
      clearCustomer: 'Wyczyść klienta',
      selectCustomer: 'Wybierz klienta',
    },
    customerSectionTitle: 'Klient',
  },
  title: {
    create: 'Dodaj kontakt',
    update: 'Edytuj kontakt',
  },
};
